import { LenderApprovalStatus } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum } from '@/utils/zodUtils';

export const ChangeLenderApprovalStatusSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      lenderApprovalStatus: requiredEnum(LenderApprovalStatus, t).nullable(),
    })
    .strict();

export type ChangeLenderApprovalStatusType = z.infer<ReturnType<typeof ChangeLenderApprovalStatusSchema>>;
